import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class InsaatMaaliyetBedelleriAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "InsaatMaliyetBedeliListe";
        super(baseUrl);
    }
    getInsaatMaaliyetBedelleriListe(yili?: number, KullanimSekliKodu?: number, InsaatSinifiKodu?: number) {
        return this.get("", { params: { yili: yili, KullanimSekliKodu: KullanimSekliKodu, InsaatSinifiKodu: InsaatSinifiKodu } })

    }
}
export default new InsaatMaaliyetBedelleriAPI();